import { render, staticRenderFns } from "./ResultatDetail.vue?vue&type=template&id=005ce144&scoped=true&"
import script from "./ResultatDetail.vue?vue&type=script&lang=js&"
export * from "./ResultatDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultatDetail.vue?vue&type=style&index=0&id=005ce144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ce144",
  null
  
)

export default component.exports